export const TO_TOP_BUTTON_IDENTIFIER = 'kmcc-to-top-button';
export const CLASSES = {
    VISIBLE: 'kmcc-to-top-button--shown',
};



// WEBPACK FOOTER //
// ./vendor/kunstmaan/cookie-bundle/Resources/ui/js/config/toTopButton.config.js